import React from "react";
import styled from "@emotion/styled";
import { CartStatus, ServiceIcons } from "@monorepo/components";
import { convertNumberToCurrency } from "@monorepo/helpers";
import theme from "@monorepo/styles/theme";
import { CartStatusesEnum, DelayStatusesEnum } from "@monorepo/types";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Typography } from "@mui/material";

interface ICartItemSummaryProps {
  sum: string;
  title: string;
  categoryId?: number;
  delayed?: DelayStatusesEnum;
  statusId?: CartStatusesEnum;
  isActive?: boolean;
}

const GreenCheckCircle = styled(CheckCircleIcon)(() => ({
  fill: theme.palette.primary.main,
  backgroundColor: theme.palette.background.paper,
  borderRadius: "50%",
}));

export const CartItemSummary: React.FC<ICartItemSummaryProps> = ({
  categoryId,
  title,
  sum,
  delayed,
  statusId,
  isActive,
}) => {
  const showSum =
    statusId !== CartStatusesEnum.OVERPAID &&
    statusId !== CartStatusesEnum.UPDATE_DATA &&
    statusId !== CartStatusesEnum.DECLARED &&
    statusId !== CartStatusesEnum.STALE &&
    statusId !== CartStatusesEnum.WAITING_INVOICE;
  const paid = statusId === CartStatusesEnum.PAID;
  const itemDelayed = delayed === DelayStatusesEnum.DELAYED;
  return (
    <>
      {categoryId && (
        <Box
          sx={{
            placeSelf: "center",
          }}
        >
          <ServiceIcons
            active={delayed === DelayStatusesEnum.NON_DELAYED}
            serviceId={categoryId}
            statusId={statusId}
            delayed={itemDelayed}
          />
        </Box>
      )}
      <Box
        sx={{
          display: "block",
          overflow: "hidden",
          color: isActive
            ? "unset"
            : delayed === DelayStatusesEnum.DELAYED || statusId === CartStatusesEnum.OVERPAID
            ? theme.palette.text.disabled
            : theme.palette.text.primary,
        }}
      >
        <Typography component="div" sx={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
          {title}
        </Typography>
        {delayed != null && statusId != null && <CartStatus statusId={statusId} delayed={delayed} />}
      </Box>
      <Typography
        fontWeight="bold"
        sx={{
          marginLeft: "auto",
        }}
      >
        {showSum && !paid && convertNumberToCurrency(Number(sum))}
        {paid && !itemDelayed && <GreenCheckCircle fontSize="large" />}
      </Typography>
    </>
  );
};
